import * as Yup from "yup";

export const ContactusSchemas = Yup.object().shape({
  FullName: Yup.string().required("Please Enter Your Full Name"),
  LastName: Yup.string().required("Please Enter Your Last Name"),
  Email: Yup.string().required("Please Enter Your Email"),
  // Number: Yup.string().required("Please Enter Your Mobile Number"),
  Message: Yup.string().required("Please Enter Your Message"),
});
